import { useState, useEffect } from "react";
import { FaUser, FaLock } from "react-icons/fa";
import { HiEye, HiEyeOff } from "react-icons/hi";
import { toast } from "react-hot-toast";

const API_URL = process.env.REACT_APP_API_URL;

export default function LoginForm({ onLoginSuccess }) {
  const [showPassword, setShowPassword] = useState(false);
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [lembrar, setLembrar] = useState(false);

  const togglePassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    const emailSalvo = localStorage.getItem("lembrarEmail");
    if (emailSalvo) {
      setUsuario(emailSalvo);
      setLembrar(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!usuario || !senha) {
      toast.error("Preencha email e senha!");
      return;
    }

    try {
      const url = `${API_URL}/login.php`.replace(/([^:]\/)\/+/g, "$1");

      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ login: usuario, senha }),
      });

      const raw = await response.text();
      console.log("🔎 Resposta bruta do servidor:", raw);

      let data;
      try {
        data = JSON.parse(raw);
      } catch (err) {
        toast.error("Servidor não retornou JSON válido. Veja o console.");
        return;
      }

      if (response.ok && data.success) {
        toast.success("Login bem-sucedido!");

        if (lembrar) {
          localStorage.setItem("lembrarEmail", usuario);
        } else {
          localStorage.removeItem("lembrarEmail");
        }

        localStorage.setItem("usuarioLogado", data.usuario.nome);
        localStorage.setItem("usuario", JSON.stringify(data.usuario));
        onLoginSuccess(data.usuario.id);
      } else {
        toast.error(data?.message || "Email ou senha inválidos.");
      }
    } catch (err) {
      console.error("Erro de login:", err);
      toast.error("Erro ao tentar fazer login!");
    }
  };

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&display=swap"
        rel="stylesheet"
      />

      <form
        onSubmit={handleLogin}
        style={{ fontFamily: "Comfortaa, cursive" }}
        className="space-y-8 flex flex-col justify-center items-center"
      >
        {/* EMAIL */}
        <div className="relative w-full max-w-sm">
          <FaUser className="absolute top-4 left-2 text-gray-500 text-lg" />
          <input
            type="email"
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
            placeholder="Digite seu email"
            className="w-full pl-10 pr-4 py-3 bg-transparent text-lg text-gray-900 
            border-b-[1px] border-gray-400 focus:border-[#f95000]
            focus:outline-none placeholder-gray-500"
          />
        </div>

        {/* SENHA */}
        <div className="relative w-full max-w-sm">
          <FaLock className="absolute top-4 left-2 text-gray-500 text-lg" />
          <input
            type={showPassword ? "text" : "password"}
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="Digite sua senha"
            className="w-full pl-10 pr-10 py-3 bg-transparent text-lg text-gray-900 
            border-b-[1px] border-gray-400 focus:border-[#f95000]
            focus:outline-none placeholder-gray-500"
          />
          <button
            type="button"
            className="absolute top-4 right-2 text-gray-500"
            onClick={togglePassword}
          >
            {showPassword ? <HiEyeOff /> : <HiEye />}
          </button>
        </div>

        {/* LEMBRAR DE MIM — FONT MAIOR */}
        <div className="flex justify-start items-center w-full">
          <label className="flex items-center gap-3 text-base text-gray-700">
            <input
              type="checkbox"
              checked={lembrar}
              onChange={(e) => setLembrar(e.target.checked)}
              className="form-checkbox text-[#f95000] h-5 w-5"
            />
            <span className="text-base">Lembrar de mim</span>
          </label>
        </div>

        {/* BOTÃO */}
        <button
          type="submit"
          className="w-full sm:w-3/4 mx-auto py-2.5 bg-[#f95000] text-white text-lg font-semibold rounded-lg shadow-md transition-transform duration-300 transform hover:scale-105"
        >
          Entrar
        </button>
      </form>
    </>
  );
}
